import React from 'react';

import { Typography } from 'antd';

import { shortName } from 'segments/utils/helpers/shortName';

interface Props {
  userName: string | null;
  coachName: string | null;
  courtName: string | null;
}

function BookingDescription({
  userName,
  coachName,
  courtName
}: Props) {
  return (
    <div style={{
      position: 'absolute',
      backgroundColor: '#ffffff82',
      width: 'calc(100% - 12px)',
      left: '6px',
      top: '2px',
      zIndex: '1',
      padding: '2px',
      borderRadius: '12px',
      maxHeight: '60px',
      overflow: 'hidden',
      pointerEvents: 'none',
      fontSize: '12px',
      lineHeight: '16px'
    }}
    >
      {userName && <Typography.Text style={{ display: 'block' }} strong>{shortName(userName)}</Typography.Text>}
      {courtName && <Typography.Text style={{ display: 'block' }} >{courtName}</Typography.Text>}
      {coachName && <Typography.Text style={{ display: 'block' }} type='secondary'>{shortName(coachName)}</Typography.Text>}
    </div>
  );
}

export default BookingDescription;
